import React from "react"
import { type ImageProps, Img, type ChakraProps, Button } from "@chakra-ui/react"
import logoFooter from "../../assets/images/logo_footer_transparent_white.png"
import SnapFireSystemsLogoMaroonImg from "../../assets/images/Snap_fire_systems_logomaroon.png"
import { useNavigate } from "react-router-dom"

export const SnapLogo = ({ props }: { props?: ImageProps }): React.ReactNode => (
  <Img width={props?.width ?? "239px"} {...props} src={logoFooter} alt="Snap Fire Systems Logo" />
)
export const SnapLogoPrimary = ({ props }: { props?: ChakraProps }): JSX.Element => {
  const navigate = useNavigate()

  return (
    <Button
      onClick={() => {
        navigate("/")
      }}
      variant={"unstyled"}
      height={"auto"}
    >
      <Img width={"239px"} {...props} src={SnapFireSystemsLogoMaroonImg} alt="Snap Fire Systems Logo" />
    </Button>
  )
}
